import htmlTruncate from 'html-truncate';

export const formatPlainText = (description, paragraphWrap = true) => {
  let formatted = paragraphWrap ? `<p>${description}</p>` : `${description}`;
  formatted = formatted.replace(/\r\n\r\n/g, '</p><p>').replace(/\n\n/g, '</p><p>');
  formatted = formatted.replace(/\r\n/g, '<br />').replace(/\n/g, '<br />');

  return formatted;
}

export const truncate = (string, truncateChars = 266) => {
  return htmlTruncate(string, truncateChars);
}

export const parseGeolocationForCourse = (course) => {
  const { geolocation, coordinates } = course;
  if(geolocation) {
    if(typeof geolocation === 'string') {
      try {
        const parsedGeolocation = geolocation.split(',', 2);
        if (parsedGeolocation.length < 2) {
          console.warn(`invalid geolocation for ${course.name}`);
          return null;
        }
        return { lat: parseFloat(parsedGeolocation[0]), lng: parseFloat(parsedGeolocation[1]) };
      } catch(e) { return null; }
    } else {
      try {
        if(geolocation.lat && geolocation.lon) {
          return {
            lat: parseFloat(geolocation.lat),
            lng: parseFloat(geolocation.lon),
          }
        }
        return null;
      } catch(e) { console.log(e); return null; }
    }
  }
  else if(coordinates){
    if(typeof coordinates === 'string') {
      try {
        const parsedGeolocation = coordinates.split(',', 2);
        if (parsedGeolocation.length < 2) {
          console.warn(`invalid geolocation for ${course.name}`);
          return null;
        }
        return { lat: parseFloat(parsedGeolocation[0]), lng: parseFloat(parsedGeolocation[1]) };
      } catch(e) { return null; }
    } else {
      try {
        if(coordinates.lat && coordinates.lon) {
          return {
            lat: parseFloat(coordinates.lat),
            lng: parseFloat(coordinates.lon),
          }
        }
        return null;
      } catch(e) { console.log(e); return null; }
    }
  }
  return null;
}



// WEBPACK FOOTER //
// ./src/utils/content-utils.js